import script from "./SourceLocationConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceLocationConfig.vue?vue&type=script&setup=true&lang=js"

import "./SourceLocationConfig.vue?vue&type=style&index=0&id=2866cd67&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2866cd67"]])

export default __exports__